import { useMemo } from 'react'
import { Dropdown } from 'components/common'
import { FilterDateInput } from 'components/common/logFilterInputs'
import useLogFilters from 'hooks/useLogFilters'
import { buildEnumOptions, FilterMeta } from 'utils/helpers'

type Props = {
  filterMeta?: FilterMeta
}

export const FILTER_FIELD_ERP_LOG = 'erpLogFilters'

const ErpLogFilterForm = ({ filterMeta }: Props) => {
  const { filters, setField } = useLogFilters(FILTER_FIELD_ERP_LOG)

  const apiTypeOptions = useMemo(
    () =>
      buildEnumOptions(filterMeta, 'apiType', [
        'INVENTORY CRON JOB',
        'ERP TO PRICING CRON',
        'BLOCK SALE STATUS CRON',
        'FRESH CRON JOB',
        'Item Cost Tracking Cron',
        'TEMP TO MAIN PRICE CRON',
        'MASTER CRON JOB',
        'AUTO ENABLE CATALOGUES',
        'MAGENTO CATALOGUE SYNC',
        'BARCODE DELETE',
      ]),
    [filterMeta],
  )

  // Options come live from `filterMeta` (same as apiType); the fallback list is
  // used only until the backend advertises `status` as an enum in filterMeta.
  const statusOptions = useMemo(
    () => buildEnumOptions(filterMeta, 'status', ['SUCCESS', 'FAILED']),
    [filterMeta],
  )

  return (
    <div className="mb-6 flex flex-wrap items-end gap-4 rounded-xl border border-gray-200 bg-white px-5 py-4 shadow-sm">
      <div className="min-w-[200px]">
        <Dropdown
          name="apiType"
          label="API Type"
          options={apiTypeOptions}
          defaultValue={filters.apiType || ''}
          setValue={(_field: string, value: string) =>
            setField('apiType', value)
          }
        />
      </div>

      <div className="min-w-[200px]">
        <Dropdown
          name="status"
          label="Status"
          options={statusOptions}
          defaultValue={filters.status || ''}
          setValue={(_field: string, value: string) =>
            setField('status', value)
          }
        />
      </div>

      <FilterDateInput
        label="Start Date"
        value={filters.startDate || ''}
        onChange={(value) => setField('startDate', value)}
      />

      <FilterDateInput
        label="End Date"
        value={filters.endDate || ''}
        onChange={(value) => setField('endDate', value)}
      />
    </div>
  )
}

export default ErpLogFilterForm
